import React from 'react';

export default function SavedFilterName({ name }) {
  return <span className="saved-filter-title">
    <span className="filter-name">{name}</span>
  </span>;
}
